import { Crown } from "lucide-react";
import type { JSX } from "react";

import { useAuth } from "./AuthProvider.js";

/**
 * Was man vor der Anmeldung sieht. Eine Hauptaktion, daneben die Registrierung —
 * beides führt zum zentralen Keycloak.
 */
export function WelcomePage(): JSX.Element {
  const { signIn, register } = useAuth();

  return (
    <main className="role-customer grid min-h-full place-items-center px-4 py-10">
      <div className="w-full max-w-sm text-center">
        <span
          className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-lg"
          style={{
            background: "linear-gradient(145deg, var(--brand), var(--accent))",
            boxShadow: "0 12px 26px -12px var(--brand)",
          }}
        >
          <Crown size={30} color="#fff" aria-hidden="true" />
        </span>

        <h1 className="text-[24px] font-extrabold tracking-[-0.03em] text-ink">BookKing</h1>
        <p className="mx-auto mt-2 max-w-[28ch] text-[14px] leading-relaxed text-ink-2">
          Alles, was man buchen kann — in einer App. Ein Account, alle Dienstleistungen.
        </p>

        <div className="mt-8 flex flex-col gap-2.5">
          <button type="button" className="btn wide lg" onClick={() => void signIn()}>
            Anmelden
          </button>
          <button type="button" className="btn ghost wide" onClick={() => void register()}>
            Konto anlegen
          </button>
        </div>

        <p className="mt-6 text-[12.5px] text-ink-3">
          Die Anmeldung läuft über das gemeinsame Konto von Community Project.
        </p>
      </div>
    </main>
  );
}
